import { isCharedi } from '../../../utils/utils';
import { isContestStage, isIdentified, isManager, isNotRegistered, isRegistered, isStudent, isTeacher, itIsMyCompetition } from '../utils';

export const buildGamificationMonstersProps = (block, state, authState) => {

  const isUserIdentified = authState?.isAuth === true;
  const { props } = block;
  if (isCharedi() && isStudent(state))
    return null;

  const buildProps = () => {

    let title = props.title?.default ?? null;
    let text = props.text?.default ?? null;
    let leftImage = props.leftImage?.default ? { ...props.leftImage?.default, src: props.leftImage?.default?.src } : null;
    let rightImage = props.rightImage?.default ? { ...props.rightImage?.default, src: props.rightImage?.default?.src } : null;
    let button = props.button || null;
    if (!isContestStage(state))
      button = null;
    if (isStudent(state) && !isContestStage(state)) {
      title = props.title?.student_before_competition ?? props.title?.default ?? null;
      text = props.text?.student_before_competition ?? props.text?.default ?? null;
      leftImage = props.leftImage?.default ? { ...props.leftImage?.default, src: props.leftImage?.default?.src } : null;
      rightImage = props.rightImage?.default ? { ...props.rightImage?.default, src: props.rightImage?.default?.src } : null;
      button = null;
    }
    else if (isStudent(state) && isUserIdentified && isContestStage(state)) {
      title = props.title?.student_after_competition ?? props.title?.default ?? null;
      text = props.text?.student_after_competition ?? props.text?.default ?? null;
      leftImage = props.leftImage?.default ? { ...props.leftImage?.default, src: props.leftImage?.default?.src } : null;
      rightImage = props.rightImage?.default ? { ...props.rightImage?.default, src: props.rightImage?.default?.src } : null;
      button = props.button || null;
    }
    else if (((isTeacher(state) || isManager(state))) && isNotRegistered(state)) {
      button = props?.registerButton ?? null;
    }
    else if (((isTeacher(state) || isManager(state))) && isRegistered(state) && !isContestStage(state)) {
      button = props?.anchorButton ?? null;
    }

    if (!isIdentified(authState) && !isContestStage(state))
      button = props?.registerButton ?? null;
    else if (!isIdentified(authState) && isContestStage(state)) {
        button = props?.IdentifyButton ?? null;
      }
    if (!itIsMyCompetition(state, authState))
      button = null;
    return {
      title,
      text,
      leftImage,
      rightImage,
      button,
    };
  };

  const resolvedProps = buildProps();

  return {
    id: block.id,
    type: block.type,
    props: resolvedProps,
  };
};

